/**
 * 判断是否为空 为空返回true
 * @param {any} val 
 * @returns {boolean}
 */
export function validataNull (val) {
    if (val instanceof Date || typeof val === 'boolean' || typeof val === 'number') return false;
    if (val instanceof Array) {
      if (val.length === 0) return true;
    } else if (val instanceof Object) {
      for (var o in val) {
        return false;
      }
      return true;
    } else {
      if (
        val === 'null' ||
        val == null ||
        val === 'undefined' ||
        val === undefined ||
        val === ''
      ) {
        return true;
      }
      return false;
    }
    return false;
  }
  function isBoolean(val){
    return typeof val === 'boolean'
  }